import { Reveal, Overline } from "./Reveal";
import { CHAPTERS } from "../data/content";

export const Chapters = () => (
  <section id="pedigree" className="relative py-28 sm:py-36" data-testid="pedigree-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline>The Pedigree — A Manifesto in Three Chapters</Overline>
        <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-stone-800 max-w-2xl leading-snug">
          Trained at India's finest. <span className="text-teal-700 italic">Practising for yours.</span>
        </h2>
      </Reveal>
      <div className="mt-16 space-y-0">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.08}>
            <article className="group relative grid md:grid-cols-[120px_1fr] gap-6 md:gap-12 py-12 border-t border-[#E3DCCB] last:border-b"
              data-testid={`chapter-${c.num}`}>
              <div className="font-serif-display text-5xl md:text-6xl font-medium text-teal-700/30 group-hover:text-teal-700/70 transition-colors duration-500">
                {c.num}
              </div>
              <div>
                <p className="font-mono-tag text-[11px] uppercase tracking-[0.25em] text-amber-600 mb-3">{c.tag}</p>
                <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-serif-display text-xl sm:text-2xl font-semibold text-stone-800">{c.title}</h3>
                  <p className="mt-1 text-sm text-teal-700/90">{c.subtitle}</p>
                </div>
                {c.logo && (
                  <img src={c.logo} alt={c.logoAlt}
                    className="hidden sm:block w-16 h-16 object-contain rounded-lg bg-white/90 p-1.5 shrink-0"
                    data-testid={`chapter-logo-${c.num}`} />
                )}
              </div>
              <p className="mt-4 text-sm sm:text-base text-stone-500 leading-relaxed max-w-3xl">{c.body}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
